export default __webpack_public_path__ + "slices/main/assets/public/media/home/homepage-community@2x.8e9341bd6479df7486c59d61a4a35ca5.jpg";